import { render } from "./ResumoPerfil.vue?vue&type=template&id=40edebef&scoped=true"
import script from "./ResumoPerfil.vue?vue&type=script&lang=js"
export * from "./ResumoPerfil.vue?vue&type=script&lang=js"

import "./ResumoPerfil.vue?vue&type=style&index=0&id=40edebef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40edebef"]])

export default __exports__